import { createNamedContext } from '@trinity/chat-components';
import type { ContextValue } from './interfaces';

export const TabViewContext = createNamedContext<ContextValue>(undefined, 'TabView.Context');